var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"engine-template-wrapper hidden h5-swiper",style:(_vm.getProjectStyle)},[(_vm.pageData && _vm.pageData.backgroundMusic)?_c('audio',{ref:"bgMusicRef",attrs:{"src":_vm.pageData.backgroundMusic,"loop":"","autoplay":_vm.pageData.backgroundMusicAutoPlay ? true : false}}):_vm._e(),_c('div',{staticClass:"swiper-container",style:(_vm.getCommonStyle({
        ..._vm.getPage.commonStyle,
        backgroundSize:
          _vm.getPage.backgroundImageStyle == 2 ? '100% 100%' : 'auto 100%',
        backgroundRepeat: 'no-repeat',
      }))},[(_vm.pageData)?_c('div',{staticClass:"swiper-wrapper"},[_c('div',{staticClass:"swiper-slide flat relative hidden"},[_c('div',{staticClass:"quark-page-wrapper",style:(_vm.getCommonStyle(
              {
                ..._vm.getPage.commonStyle,
                top: _vm.pageTop,
                height: _vm.pageData.height,
                width: _vm.pageData.width,
                position: 'relative',
                backgroundImage: 'none',
              },
              _vm.scalingRatio
            ))},[_vm._l((_vm.elementGroups.filter(
              (i) => !i.dynamicPanelUUID
            )),function(item,index){return _c('componentsGroupTemplate',{key:index,style:(_vm.getCommonStyle(
                {
                  ...item.defaultStyle,
                  zIndex: item.zIndex,
                  display: item.display ? item.display : 'block',
                },
                _vm.scalingRatio
              )),attrs:{"element":item,"elementsAll":_vm.elementsAll,"elementGroups":_vm.elementGroups,"scalingRatio":_vm.scalingRatio},on:{"router":_vm.changeRouter}})}),_vm._l((_vm.elements.filter(
              (i) => !i.dynamicPanelUUID
            )),function(item,index){return _c('componentsTemplate',{key:index,style:(_vm.getCommonStyle(
                {
                  ...(item.isDynamicPanel
                    ? { ...item.commonStyle, overflow: 'hidden' }
                    : item.commonStyle),
                },
                _vm.scalingRatio
              )),attrs:{"loaded":item._loaded,"element":item,"elementsAll":_vm.elementsAll,"elementGroups":_vm.elementGroups,"scalingRatio":_vm.scalingRatio},on:{"router":_vm.changeRouter}},[(item.isDynamicPanel && !_vm.dynamicPanelStatesRefreshing)?_c('dynamic-panel-self',{attrs:{"item":item,"dynamicPanelStatesCheck":_vm.dynamicPanelStatesCheck,"elementsAll":_vm.elementsAll,"elementGroups":_vm.elementGroups,"scalingRatio":_vm.scalingRatio},on:{"router":_vm.changeRouter}}):_vm._e()],1)})],2)])]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }